var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d020d3bbda9d491474fb334ec72ee16038338ae6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@higher-learning-technologies"]={id:"d020d3bbda9d491474fb334ec72ee16038338ae6"};
      